import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments';
import { SpResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private base = environment.apiBaseUrl;
  constructor(private http: HttpClient){}

  get<T=any>(url:string, params?:Record<string,any>){
    let p = new HttpParams();
    if (params) Object.keys(params).forEach(k => {
      const v = params[k];
      if (v === undefined || v === null || v === '') return;
      p = p.set(k, String(v));
    });
    return this.http.get<SpResponse<T>>(`${this.base}${url}`, { params: p });
  }
  post<T=any>(url:string, body:any){ return this.http.post<SpResponse<T>>(`${this.base}${url}`, body); }
  patch<T=any>(url:string, body:any){ return this.http.patch<SpResponse<T>>(`${this.base}${url}`, body); }
  delete<T=any>(url:string){ return this.http.delete<SpResponse<T>>(`${this.base}${url}`); }
}
